import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {standardStreng} from "felles-ng2/støttefunksjoner/strenger";
import {Region} from "felles-ng2/tjenester/i18n/GjeldendeLokale";

const debug = initDebugger('FlaggKomponent');

@Component({
    selector: 'flagg',
    templateUrl: './flagg.html',
    styleUrl: './flagg.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlaggKomponent {

    land = input.required<Region | null>();
    hoyde = input<number>(24);

    landUppercase = computed(() => standardStreng(this.land(), '').toUpperCase());
    bredde = computed(() => this.hoyde() * (4 / 3));

    constructor() {
    }
}
